import noise3D from '../../../_shaders/noise3-d'
import hsv_rgb from '../../../_shaders/hsv-rgb'

export default `${noise3D + hsv_rgb}
uniform vec3 uBaseColor;
uniform vec4 uRectData;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uLightDirection;
uniform float uLightIntensity;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;

float getFresnel(vec3 normal, float power) {
  vec3 viewDir = vec3(0.0, -0.5, 1.0);
  return 1.0 - pow(max(dot(viewDir, normal), 0.0), power);
}

void main(){
  float light = max(0.0, dot(normalize(vNormal2), normalize(uLightDirection)));
  vec3 color = uBaseColor;

  color = pow(color, vec3(1.0/2.2));
  gl_FragColor = vec4(color, 1.0);
}
`
